module.exports = __webpack_public_path__ + "img/ic-acessibilidade-contraste.b429285b.svg";